// extracted by mini-css-extract-plugin
export var backupIcon = "_o3-1";
export var image = "_o3-0";